import { match } from 'ts-pattern';

import { VerificationResult, VerificationStatus } from '@/types/customerKYXVerification';

export interface VerificationStatusSpecs {
  readonly label: string;
  readonly backgroundColor: string;
  readonly color: string;
}

const completedStatuses = [VerificationStatus.COMPLETED];
const pendingStatuses = [
  VerificationStatus.PENDING,
  VerificationStatus.RUNNING,
  VerificationStatus.SUBMITTED,
];
const failedStatuses = [VerificationStatus.FAILED];
const notStartedStatuses = [VerificationStatus.NOT_STARTED];

export const verificationStatusSpecs = (status: VerificationStatus): VerificationStatusSpecs =>
  match(status)
    .when(
      (status: VerificationStatus): boolean => completedStatuses.includes(status),
      (): VerificationStatusSpecs => ({
        label: status,
        backgroundColor: 'status.completed.background',
        color: 'status.completed.foreground',
      }),
    )
    .when(
      (status: VerificationStatus): boolean => pendingStatuses.includes(status),
      (): VerificationStatusSpecs => ({
        label: status,
        backgroundColor: 'status.pending.background',
        color: 'status.pending.foreground',
      }),
    )
    .when(
      (status: VerificationStatus): boolean => failedStatuses.includes(status),
      (): VerificationStatusSpecs => ({
        label: status,
        backgroundColor: 'status.failed.background',
        color: 'status.failed.foreground',
      }),
    )
    .when(
      (status: VerificationStatus): boolean => notStartedStatuses.includes(status),
      (): VerificationStatusSpecs => ({
        label: status,
        backgroundColor: 'custom.InactiveBackground',
        color: 'secondary.main',
      }),
    )
    .otherwise(
      (): VerificationStatusSpecs => ({
        label: status,
        color: 'inherit',
        backgroundColor: 'inherit',
      }),
    );

const approvedResults = [VerificationResult.APPROVED];
const declinedResults = [VerificationResult.DECLINED];
const reviewResults = [VerificationResult.REVIEW];
const unknownResults = [VerificationResult.UNKNOWN];

export const verificationResultSpecs = (result: VerificationResult): VerificationStatusSpecs =>
  match(result)
    .when(
      (result: VerificationResult): boolean => approvedResults.includes(result),
      (): VerificationStatusSpecs => ({
        label: result,
        backgroundColor: 'status.completed.background',
        color: 'status.completed.foreground',
      }),
    )
    .when(
      (result: VerificationResult): boolean => declinedResults.includes(result),
      (): VerificationStatusSpecs => ({
        label: result,
        backgroundColor: 'status.failed.background',
        color: 'status.failed.foreground',
      }),
    )
    .when(
      (result: VerificationResult): boolean => reviewResults.includes(result),
      (): VerificationStatusSpecs => ({
        label: result,
        backgroundColor: 'status.pending.background',
        color: 'status.pending.foreground',
      }),
    )
    .when(
      (result: VerificationResult): boolean => unknownResults.includes(result),
      (): VerificationStatusSpecs => ({
        label: result,
        backgroundColor: 'custom.InactiveBackground',
        color: 'secondary.main',
      }),
    )
    .otherwise(
      (): VerificationStatusSpecs => ({
        label: result,
        color: 'inherit',
        backgroundColor: 'inherit',
      }),
    );
